import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { dismissUrl: String }

  connect() {
    // Auto-show modal on page load
    this.modalTarget.classList.remove("hidden")
  }

  dismiss() {
    this.modalTarget.classList.add("hidden")

    // Persist dismissal server-side
    if (this.dismissUrlValue) {
      fetch(this.dismissUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Content-Type": "application/json"
        }
      })
    }
  }

  startTour() {
    this.dismiss()
    window.location.href = "/?tour=true"
  }
}
